export default __webpack_public_path__ + "static/media/CD.632173c9.ico";